
export const EDITOR_READY = "EDITOR_READY";
export function editorReady() {
    return {
        type: EDITOR_READY,
    };
}
